import { put } from 'redux-saga/effects';
import {
  createNR01StockGruppe,
  deleteNR01StockGruppe,
  fetchNR01StockGruppeOverview,
  updateNR01StockGruppe,
} from '../../felles/APICalls_NR01';
import * as actions from '../actions';
import * as actionsNR01 from '../actions/indexNR01';

export function* fetchNR01StockGruppeSaga(action: any): Generator<any, void, any> {
  try {
    yield put(actions.setIsloading(true));
    const { companyId, page, pageSize, search, sortBy, sortDirection } = action.payload;

    const response = yield fetchNR01StockGruppeOverview(companyId, page, pageSize, search, sortBy, sortDirection);

    if (response && response.data) {
      yield put(actionsNR01.fetchNR01StockGruppeSuccess(response.data));
    } else {
      yield put(actionsNR01.fetchNR01StockGruppeFailure('Ingen data mottatt'));
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Ukjent feil';
    yield put(actionsNR01.fetchNR01StockGruppeFailure(errorMessage));
  } finally {
    yield put(actions.setIsloading(false));
  }
}

// No global loading overlay: the rows already shown stay, with a spinner under the table.
export function* loadMoreNR01StockGruppeSaga(action: any): Generator<any, void, any> {
  try {
    const { companyId, page, pageSize, search, sortBy, sortDirection } = action.payload;

    const response = yield fetchNR01StockGruppeOverview(companyId, page, pageSize, search, sortBy, sortDirection);

    if (response && response.data) {
      yield put(actionsNR01.loadMoreNR01StockGruppeSuccess(response.data));
    } else {
      yield put(actionsNR01.loadMoreNR01StockGruppeFailure('Ingen data mottatt'));
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Kunne ikke laste flere rader. Prøv igjen.';
    yield put(actionsNR01.loadMoreNR01StockGruppeFailure(errorMessage));
  }
}

export function* createNR01StockGruppeSaga(action: any): Generator<any, void, any> {
  try {
    yield put(actions.setIsloading(true));
    const { companyId, payload } = action.payload;

    const response = yield createNR01StockGruppe(companyId, payload);

    if (response && response.data) {
      yield put(actionsNR01.createNR01StockGruppeSuccess(response.data));
      yield put(actionsNR01.fetchNR01StockGruppeRequest(companyId, 1, 100));
    } else {
      yield put(actionsNR01.createNR01StockGruppeFailure('Oppretting feilet'));
    }
  } catch (error: any) {
    let errorMessage = 'Ukjent feil';

    if (error?.response?.status === 409) {
      errorMessage = 'Varegruppen finnes allerede. Vennligst bruk et annet gruppenummer.';
    } else {
      errorMessage = error?.response?.data?.message || error?.message || 'Ukjent feil';
    }

    yield put(actionsNR01.createNR01StockGruppeFailure(errorMessage));
  } finally {
    yield put(actions.setIsloading(false));
  }
}

export function* deleteNR01StockGruppeSaga(action: any): Generator<any, void, any> {
  try {
    yield put(actions.setIsloading(true));
    const { companyId, groupNumber } = action.payload;

    const response = yield deleteNR01StockGruppe(companyId, groupNumber);

    if (response && response.data) {
      yield put(actionsNR01.deleteNR01StockGruppeSuccess(response.data));
      yield put(actionsNR01.fetchNR01StockGruppeRequest(companyId, 1, 100));
    } else {
      yield put(actionsNR01.deleteNR01StockGruppeFailure('Sletting feilet'));
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Ukjent feil';
    yield put(actionsNR01.deleteNR01StockGruppeFailure(errorMessage));
  } finally {
    yield put(actions.setIsloading(false));
  }
}

export function* updateNR01StockGruppeSaga(action: any): Generator<any, void, any> {
  try {
    yield put(actions.setIsloading(true));
    const { companyId, groupNumber, payload } = action.payload;

    const response = yield updateNR01StockGruppe(companyId, groupNumber, payload);

    if (response && response.data) {
      yield put(actionsNR01.updateNR01StockGruppeSuccess(response.data));
      yield put(actionsNR01.fetchNR01StockGruppeRequest(companyId, 1, 100));
    } else {
      yield put(actionsNR01.updateNR01StockGruppeFailure('Oppdatering feilet'));
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Ukjent feil';
    yield put(actionsNR01.updateNR01StockGruppeFailure(errorMessage));
  } finally {
    yield put(actions.setIsloading(false));
  }
}
